import { ToolbarItemProps } from "../components/toolbar-item.types";

export enum ToolbarActionType {
  REPLACE_STATE = "REPLACE_STATE",
  SET_ITEMS_WIDTH = "SET_ITEMS_WIDTH",
  SET_ITEMS_VISIBILITY = "SET_ITEMS_VISIBILITY",
  CLEAR_MEASUREMENT = "CLEAR_MEASUREMENT",
  SET_IS_SMALL_SCREEN = "SET_IS_SMALL_SCREEN",
  CLOSE_SHOW_MORE_DROPDOWN = "CLOSE_SHOW_MORE_DROPDOWN",
  CLOSE_ALL_TOOLBAR_ITEM_DROPDOWNS = "CLOSE_ALL_TOOLBAR_ITEM_DROPDOWNS",
}

interface ReplaceStateAction {
  type: ToolbarActionType.REPLACE_STATE;
  changedToolbarSchema: ToolbarItemProps[];
}

interface SetItemsWidthAction {
  type: ToolbarActionType.SET_ITEMS_WIDTH;
  toolbarItemsWidth: { width: number }[];
}

interface SetItemsVisibilityAction {
  type: ToolbarActionType.SET_ITEMS_VISIBILITY;
  toolbarContainerWidth: number;
  showMoreButtonWidth?: number;
  showToolbarItemsInSmallScreen?: boolean;
}

interface ClearMeasurmentAction {
  type: ToolbarActionType.CLEAR_MEASUREMENT;
}

interface SetIsSmallScreenAction {
  type: ToolbarActionType.SET_IS_SMALL_SCREEN;
  windowWidth: number;
}

interface CloseShowMoreDropdownAction {
  type: ToolbarActionType.CLOSE_SHOW_MORE_DROPDOWN;
  inProgress: boolean;
}

interface CloseAllToolbarItemDropdownsAction {
  type: ToolbarActionType.CLOSE_ALL_TOOLBAR_ITEM_DROPDOWNS;
  inProgress: boolean;
}

export type ToolbarAction =
  | SetItemsWidthAction
  | SetItemsVisibilityAction
  | ReplaceStateAction
  | ClearMeasurmentAction
  | SetIsSmallScreenAction
  | CloseShowMoreDropdownAction
  | CloseAllToolbarItemDropdownsAction;
